// extracted by mini-css-extract-plugin
module.exports = {"container":"CardType_container__39XJv","typeText":"CardType_typeText__2V_i1","gray":"CardType_gray__1ThPi"};